import httpService from '../../../core/services/HttpService';

export type SwapRequestStatus = 'pending' | 'cancelled' | 'fulfilled' | 'rejected';

export interface SwapCandidateInput {
  target_shift_id: number;
  target_employee_id: number;
}

export interface SwapRequestCreateBody {
  requester_shift_id: number;
  candidates: SwapCandidateInput[];
  expires_at?: string | null;
  note?: string;
}

export interface SwapOption {
  id: number;
  type: 'swap';
  target_shift_id: number;
  target_employee_id: number;
  status: SwapRequestStatus | 'pending';
}

export interface SwapRequestMinimal {
  id: number;
  status: SwapRequestStatus | 'pending';
  requester_shift_id: number;
  requester_employee_id?: number;
  options: SwapOption[];
}

export interface SwapRequestDetailOption {
  option_id: number;
  type: 'swap';
  status: SwapRequestStatus | 'pending';
  target_employee: { id: number; name: string };
  target_shift: { id: number; date: string; start: string; end: string; work_area: string };
}

export interface SwapRequestDetail {
  id: number;
  status: SwapRequestStatus | 'pending';
  created_at: string;
  requester_employee?: { id: number; name: string };
  requester_shift: { id: number; date: string; start: string; end: string; work_area: string };
  options: SwapRequestDetailOption[];
  expires_at: string | null;
  note?: string;
}

export interface SwapRequestsQuery {
  status?: SwapRequestStatus | 'pending';
  requester_shift_id?: number;
  id?: number;
  start_date?: string;
  end_date?: string;
}

class SwapService {
  static async createSwapRequest(body: SwapRequestCreateBody): Promise<SwapRequestMinimal> {
    const res = await httpService.post('/api/shifts/swaps/requests/', body);
    return res.data as SwapRequestMinimal;
  }

  static async listSwapRequests(query: SwapRequestsQuery): Promise<SwapRequestMinimal[]> {
    const params: any = {};
    if (query.status) params.status = query.status;
    if (query.requester_shift_id) params.requester_shift_id = query.requester_shift_id;
    if (query.id) params.id = query.id;
    if (query.start_date) params.start_date = query.start_date;
    if (query.end_date) params.end_date = query.end_date;

    try {
      console.log('[SwapService] GET /api/admin/shifts/swap-indicators/', params);
      const res = await httpService.get('/api/admin/shifts/swap-indicators/', { params });
      const raw = res.data;
      console.log('[SwapService] raw response:', raw);

      // Flatten: extract all objects that have shift_id
      const indicators: any[] = [];
      const extract = (obj: any) => {
        if (!obj || typeof obj !== 'object') return;
        if (Array.isArray(obj)) { obj.forEach(extract); return; }
        if (obj.shift_id != null && !isNaN(Number(obj.shift_id))) {
          indicators.push(obj);
        } else {
          Object.values(obj).forEach(extract);
        }
      };
      extract(raw);

      console.log('[SwapService] parsed indicators =>', indicators.length, indicators);
      return indicators;
    } catch (e: any) {
      console.warn('[SwapService] swap-indicators failed:', e?.status, e?.data || e?.message);
      return [];
    }
  }

  static async getSwapRequest(id: number): Promise<SwapRequestDetail> {
    const res = await httpService.get(`/api/shifts/swaps/requests/${id}/`);
    return res.data as SwapRequestDetail;
  }

  static async respondToSwap(id: number, action: 'accept' | 'decline' | 'takeover'): Promise<any> {
    const res = await httpService.post(`/api/shifts/swaps/${id}/respond/`, { action });
    return res.data;
  }

  static async cancelSwapRequest(id: number): Promise<{ status: 'cancelled' }> {
    const res = await httpService.post(`/api/shifts/swaps/${id}/cancel`);
    return res.data as { status: 'cancelled' };
  }
}

export default SwapService;
